/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupplementsApiDto } from './supplements.model';
import { VacationApiDto } from './vacation.model';
import { LessonApiDto } from './lesson.model';
import { PackageProductApiDto } from './package-product.model';
import { DateRangeApiDto } from './date-range.model';
import { LimitedCurrencyAmountApiDto } from './limited-currency-amount.model';

export interface QuoteProductApiDto {
  schoolProductId?: number;
  descriptions?: Array<string>;
  selectedWeeks?: Array<DateRangeApiDto>;
  isRemovable?: boolean;
  articleDescriptions?: Array<string>;
  discountTotalAsPercentage?: string;
  includedProducts?: Array<PackageProductApiDto>;
  code?: string;
  name?: string;
  articleIds?: Array<number>;
  referenceIds?: Array<number>;
  vat?: number;
  argoServiceCode?: string;
  price?: Array<LimitedCurrencyAmountApiDto>;
  priceProvider?: number;
  endPrice?: Array<LimitedCurrencyAmountApiDto>;
  providerName?: string;
  promotionsApplied?: Array<number>;
  priceOnRequest?: boolean;
  classification?: QuoteProductApiDto.ClassificationEnum;
  units?: number;
  startDate?: string;
  endDate?: string;
  discount?: Array<LimitedCurrencyAmountApiDto>;
  transferServiceType?: QuoteProductApiDto.TransferServiceTypeEnum;
  transferStation?: string;
  row?: number;
  extras?: SupplementsApiDto;
  supplements?: SupplementsApiDto;
  vacations?: Array<VacationApiDto>;
  seasonVariation?: boolean;
  lesson?: LessonApiDto;
  articleName?: string;
  durationDescription?: string;
  productType?: string;
}
export namespace QuoteProductApiDto {
  export const ClassificationEnum = {
    TUITION: 'TUITION',
    PRIVATE_LESSONS: 'PRIVATE_LESSONS',
    ACCOMMODATION: 'ACCOMMODATION',
    TRANSFER: 'TRANSFER',
    INSURANCE: 'INSURANCE',
    SUPPLEMENT: 'SUPPLEMENT',
    PREMIUM_ACTIVITIES: 'PREMIUM_ACTIVITIES',
    FEE: 'FEE',
    OTHERS: 'OTHERS',
    PREMIUM_RESIDENCE: 'PREMIUM_RESIDENCE',
    OPT_OUT: 'OPT_OUT',
    PIE: 'PIE',
  } as const;
  export type ClassificationEnum = (typeof ClassificationEnum)[keyof typeof ClassificationEnum];
  export const TransferServiceTypeEnum = {
    ARRIVAL: 'ARRIVAL',
    DEPARTURE: 'DEPARTURE',
    ROUND_TRIP: 'ROUND_TRIP',
    NO_TRANSFER: 'NO_TRANSFER',
  } as const;
  export type TransferServiceTypeEnum = (typeof TransferServiceTypeEnum)[keyof typeof TransferServiceTypeEnum];
}
